import _ from "lodash";
import { DateTime } from "luxon";

export const formatDate = (date: any, format = "LL/dd/yyyy") => {
    if (_.isEmpty(date) || _.isEmpty(format)) {
        return date;
    }
    try {
        const dt = typeof (date) === "string" ? DateTime.fromISO(date, { zone: "utc" }).toLocal() : DateTime.fromJSDate(date);
        return dt.toFormat(format);
    } catch (e) {
        return date;
    }
};

export const formatDateTime = (date: any, format = "LL/dd/yyyy hh:mm a") => {
    if (_.isEmpty(date) || _.isEmpty(format)) {
        return date;
    }
    try {
        const dt = typeof (date) === "string" ? DateTime.fromISO(date, { zone: "utc" }).toLocal() : DateTime.fromJSDate(date);
        return dt.toFormat(format);
    } catch (e) {
        return date;
    }
};
